import React from "react";
import logo from "../assets/logo.png";

const Header = () => {
  const headerStyle = {
    position: "sticky",
    top: 0,
    zIndex: 50,
    backdropFilter: "blur(12px)",
    background: "rgba(249, 250, 251, 0.85)",
    borderBottom: "1px solid rgba(229, 231, 235, 0.8)",
  };

  return (
    <header style={headerStyle}>
      <div className="header-container">
        {/* Full-size image display (no wrapped container, no forced sizes) */}
        <img src={logo} alt="EcoPro Earth" className="header-logo" />
      </div>
    </header>
  );
};

export default Header;
